//local
//export const apiService = 'https://localhost:7094/api/';

//dev
//export const apiService = 'https://hrm-ddif.dev.smartdanang.vn/api/';

//publish
export const apiService = 'https://qldh-api.ddif.com.vn/api/';

export const ApiPaths = {
    menu: `${apiService}ChucNang/LayMenu`,
    login: {
        SSO: `${apiService}account/LoginSSO`,
        System: `${apiService}account/Login`,
    },
    danhMucDiaPhuong: {
        layDsTinhThanh: `${apiService}danhmuc/LayTatCaDSTinhThanh`,
        layDSPhuongXaTheoIdTinhThanh: `${apiService}danhmuc/LayDSPhuongXaTheoIdTinhThanh`,
    },
    donVi: {
        layDS: `${apiService}donvi/layDS`,
        layTatCa: `${apiService}donvi/layTatCa`,
        xoa: `${apiService}donvi/xoa`,
        chitiet: `${apiService}donvi/layct`,
        luu: `${apiService}donvi/luu`,
        layDsToanBoDonVi: `${apiService}donvi/layDS`,
        layDsDonViPhuTrach: `${apiService}donvi/layDSDonViPhuTrach`,
        layDSDonViPhuTrachTheoIdNhanVien: `${apiService}donvi/LayDSDonViPhuTrachTheoIdNhanVien`,
    },
    chucNang: {
        danhSachTree: `${apiService}chucnang/LayDSTree`,
        xoa: `${apiService}chucnang/xoa`,
        chitiet: `${apiService}chucnang/layct`,
        luu: `${apiService}chucnang/luu`,
        dsTheoIdQuyen: `${apiService}chucnang/LayDSChucNangTheoIdQuyen`,
        layDsChucNangRieng: `${apiService}chucnang/LayDSChucNangRiengTheoIdNguoiDung`,
        luuChucNangRieng: `${apiService}chucnang/LuuChucNangRiengTheoIdNguoiDung`,
        layDsChucNangDiKemQuyen: `${apiService}chucnang/LayDSChucNangDiKemQuyenTheoIdNguoiDung`,
    },
    quyen: {
        layToanBo: `${apiService}quyen/LayToanBoDSQuyen`,
        luuChucNangQuyen: `${apiService}quyen/LuuChucNang`,
        luuQuyen: `${apiService}quyen/LuuQuyen`,
        xoaQuyen: `${apiService}quyen/XoaQuyen`,
        layDsQuyenTheoIdNguoiDung: `${apiService}quyen/LayDSQuyenTheoIdNguoiDung`,
        luuQuyenTheoIdNguoiDung: `${apiService}quyen/LuuQuyenTheoIdNguoiDung`,
        layDSNhanVienTheoIdQuyen: `${apiService}quyen/LayDSNhanVienTheoIdQuyen`,
    },
    caNhan: {
        luuThongTin: `${apiService}nguoiDung/LuuThongTinCaNhan`,
        layThongTin: `${apiService}nguoiDung/LayCT`,
        doiMatKhau: `${apiService}nguoiDung/DoiMatKhau`
    },
    nguoiDung: {
        LayDSTaiKhoan: `${apiService}nguoiDung/LayDSTaiKhoan`,
        LayCTNguoiDung: `${apiService}nguoiDung/LayCTNguoiDung`,
        xoaTaiKhoan: `${apiService}nguoiDung/XoaTaiKhoan`,
        themTaiKhoan: `${apiService}nguoiDung/themTaiKhoan`,
        kichHoatTaiKhoan: `${apiService}nguoiDung/kichHoatTaiKhoan`,
        datLaiMatKhau: `${apiService}nguoiDung/DatLaiMatKhau`,
        quenMatKhau: `${apiService}nguoiDung/GuiEmailDatLaiMatKhau`
    },
    nhanVien: {
        timKiemDsNhanVien: `${apiService}nhanVien/TimKiemDSNhanVien`,
        layCTNhanVien: `${apiService}nhanVien/LayCTNhanVien`,
        xoaNhanVien: `${apiService}nhanVien/XoaNhanVien`,
        layThongTinTheoMaChucVu: `${apiService}nhanVien/LayThongTinNhanVienTheoMaChucVu`,
        luuNhanVien: `${apiService}nhanVien/LuuNhanVien`,
        luuDanhGiaXepLoai: `${apiService}nhanVien/LuuDanhGiaXepLoai`,
        xoaDanhGiaXepLoai: `${apiService}nhanVien/XoaDanhGiaXepLoai`,
        luuQuaTrinhLamViec: `${apiService}nhanVien/LuuQuaTrinhLamViec`,
        xoaQuaTrinhLamViec: `${apiService}nhanVien/XoaQuaTrinhLamViec`,
        luuKhenThuong: `${apiService}nhanVien/LuuKhenThuong`,
        xoaKhenThuong: `${apiService}nhanVien/XoaKhenThuong`,
        luuKyLuat: `${apiService}nhanVien/LuuKyLuat`,
        xoaKyLuat: `${apiService}nhanVien/XoaKyLuat`,
        luuChungChi: `${apiService}nhanVien/LuuChungChi`,
        xoaChungChi: `${apiService}nhanVien/XoaChungChi`,
        luuTrinhDoHocVan: `${apiService}nhanVien/LuuTrinhDoHocVan`,
        xoaTrinhDoHocVan: `${apiService}nhanVien/XoaTrinhDoHocVan`,
        luuQuaTrinhCongTac: `${apiService}nhanVien/LuuQuaTrinhCongTac`,
        xoaQuaTrinhCongTac: `${apiService}nhanVien/XoaQuaTrinhCongTac`,
        luuNguoiPhuThuoc: `${apiService}nhanVien/LuuNguoiPhuThuoc`,
        xoaNguoiPhuThuoc: `${apiService}nhanVien/XoaNguoiPhuThuoc`,
        timKiemNguoiPhuThuocToanDonVi: `${apiService}nhanVien/TimKiemNguoiPhuThuocToanDonVi`,
        xuatExcelNguoiPhuThuocToanDonVi: `${apiService}report/XuatExcelNguoiPhuThuocToanDonVi`,
        layDSToanBoNhanVien: `${apiService}nhanVien/LayDS`,
        layDSNhanVienTheoQuyen: `${apiService}nhanVien/LayDSNhanVienTheoQuyen`, 
        danhSachTree: `${apiService}nhanVien/LayDSTree`,
        luuAnhDaiDien: `${apiService}nhanVien/LuuAnhDaiDien`,
        layCTLanhDaoPhuTrachPhongTheoIdDonVi: `${apiService}nhanVien/LayCTLanhDaoPhuTrachPhongTheoIdDonVi`,
        LayDsPhoGiamDocPhuTrach: `${apiService}nhanVien/LayDanhSachPhoGiamDocPhuTrach`,
        LayDsNLDTheoIdDonVi: `${apiService}nhanVien/LayDsNLDTheoIdDonVi`,
        LayDsNLDTheoIdDonVi_V2: `${apiService}nhanVien/LayDsNLDTheoIdDonVi_V2`,
        ThongKeNhanVien: `${apiService}nhanVien/ThongKeNhanVien`,
        LayDSNhanVienTheoThamNienCongTac: `${apiService}nhanVien/LayDSNhanVienTheoThamNienCongTac`,
        ThongKeNhanSuTheoPhongBan: `${apiService}nhanVien/ThongKeNhanSuTheoPhongBan`,
        ThongKeNhanSuTheoChucDanh: `${apiService}nhanVien/ThongKeNhanSuTheoChucDanhTrongDonVi`,
        luuTaiLieuNguoiPhuThuoc: `${apiService}nhanVien/LuuFileNguoiPhuThuoc`,
        xoaTaiLieuNguoiPhuThuoc: `${apiService}nhanVien/XoaFileNguoiPhuThuoc`,
        luuTaiLieuHoSoNhanSu: `${apiService}nhanVien/LuuFileHoSoNhanSu`,
        xoaTaiLieuHoSoNhanSu: `${apiService}nhanVien/XoaFileHoSoNhanSu`,
        layDSNhanVienGiaoViec: `${apiService}nhanVien/LayDanhSachNhanVienGiaoViec`,
        ThongKeNhanSuDoanDangTheoPhongBan: `${apiService}nhanVien/ThongKeNhanSuDoanDang`,
    },
    setting: {
        luu: `${apiService}setting/luu`,
        luuCauHinhHopDong: `${apiService}setting/luuCauHinhHopDong`,
        layCauHinhHopDong: `${apiService}setting/layCauHinhHopDong`,
        luuCauHinhNgayLamViec: `${apiService}setting/luuCauHinhNgayLamViec`,
        laytatca: `${apiService}setting/laytatca`,
        layTheoMaCauHinh: `${apiService}setting/laytheomacauhinh`,
        layNgayNghiTrongTuan: `${apiService}setting/LayNgayNghiTrongTuan`,
        layTatCaDSCauHinhNgayNghi: `${apiService}setting/LayTatCaDSCauHinhNgayNghi`,
        luuLanhDaoPhuTrachPhong: `${apiService}setting/LuuLanhDaoPhuTrachPhong`,
        luuCauHinhLuong: `${apiService}setting/luuCauHinhLuong`, 
        luuCauHinhThue: `${apiService}setting/luuCauHinhThue`, 
        layCauHinhThue: `${apiService}setting/layCauHinhThue`, 
        luuCauHinhHanChotKPI: `${apiService}setting/luuCauHinhHanChotKPI`,
        layDSCauHinhHanChotKPI: `${apiService}setting/layDSCauHinhHanChotKPI`, 
        xoaCauHinhHanChotKPI: `${apiService}setting/xoaCauHinhHanChotKPI`, 
        layDSSoHieuVanBan: `${apiService}setting/LayDSSoHieuVanBan`,
        luuSoHieuVanBan: `${apiService}setting/LuuSoHieuVanBan`,
        xoaSoHieuVanBan: `${apiService}setting/XoaSoHieuVanBan`,
    },
    hopDong: {
        taoHopDongDienTu: `${apiService}hopDong/taoHopDongDienTu`,
        luuHopDongDienTu: `${apiService}hopDong/LuuHopDongDienTu`,
        pheDuyetHopDongDienTu: `${apiService}hopDong/PheDuyetHopDongDienTu`,
        layChiTietHopDongDienTu: `${apiService}hopDong/LayChiTietHopDongDienTu`,
        xemPdfHopDongDienTu: `${apiService}hopDong/XemPdfHopDongDienTu`,
        kySo: `${apiService}hopDong/kySo`,
        laySoHopDongDienTu: `${apiService}hopDong/LaySoHopDongDienTu`,
        layDsTheoIdNhanVien: `${apiService}hopDong/LayDsHopDongTheoIdNhanVien`,
        layCT: `${apiService}hopDong/LayChiTiet`,
        luuQDBacLuong: `${apiService}hopDong/LuuQuyetDinhBacLuong`,
        xoaQDBacLuong: `${apiService}hopDong/XoaQuyetDinhBacLuong`,
        luuPhuCapNhanSu: `${apiService}hopDong/LuuPhuCapNhanSu`,
        xoaPhuCapNhanSu: `${apiService}hopDong/XoaPhuCapNhanSu`,
        luuHopDong: `${apiService}hopDong/LuuHopDong`,
        xoaHopDong: `${apiService}hopDong/XoaHopDong`,
        layHopDongHetHan: `${apiService}hopDong/LayHopDongHetHan`,
        layTienPhuCap: `${apiService}hopDong/LayTienPhuCap`,
        layDSPhuCapTheoHDvaQDBL: `${apiService}hopDong/LayDanhSachPhuCapTheoHopDongVaQDBL`,
        timKiemDSNhanVienHopDong: `${apiService}hopDong/TimKiemDSNhanVienHopDong`,
        timKiemDSHopDongDienTu: `${apiService}hopDong/TimKiemDSHopDongDienTu`,
        layDsQDBLTheoIdNhanVien: `${apiService}hopDong/LayDsQuyetDinhBacLuongTheoIdNhanVien`,
    },
    luong: {
        get: `${apiService}luong/get`,
        quanLyLuong: `${apiService}luong/quanlyluong`,
        khoiTaoLuong: `${apiService}luong/khoitaoluong`,
        themKyLuong: `${apiService}luong/ThemMoiKyLuong`,
        dieuChinhBangLuongThang: `${apiService}luong/DieuChinhBangLuong`,

        xuatLuongBoSung: `${apiService}luong/XuatDuLieuLuongBoSung`,
        importFileChamCong: `${apiService}luong/ImportFileLuongBoSung`,
        taiDuLieuTinhLuongBoSung: `${apiService}luong/TaiDuLieuTinhLuongBoSung`,
        luuLuongBoSung: `${apiService}luong/LuuLuongBoSung`,
        luuLuongBoSungNLD: `${apiService}luong/LuuLuongBoSungNguoiLaoDong`,
        xuatExcelLuongBoSungNLD: `${apiService}luong/XuatExcelLuongBoSungNLD`,
        layDuLieuLuongBoSung: `${apiService}luong/layDuLieuLuongBoSung`,
        
        khoaDieuChinh: `${apiService}luong/CapNhatTrangThaiKyLuong`,
        layDLNhanVienMucLuongPhuCap: `${apiService}luong/LayDuLieuNhanVienMucLuongPhuCapData`,
        layDsKhenThuongUngHo: `${apiService}luong/LayDsKhenThuongUngHo`,
        layChiTietKhenThuongUngHo: `${apiService}luong/LayChiTietLuongKhenThuongUngHo`,
        luuTaiLieuLuongKhenThuongUngHo: `${apiService}luong/LuuTaiLieuLuongKhenThuongUngHo`,
        layDsTaiLieuLuongKhenThuongUngHo: `${apiService}luong/LayDsTaiLieuLuongKhenThuongUngHo`,
        layDsPhatSinhTinhThue: `${apiService}luong/LayDsPhatSinhTinhThue`,
        layChiTietPhatSinhTinhThue: `${apiService}luong/LayChiTietPhatSinhTinhThue`,
        taiDuLieuLuongBoSungNguoiLD: `${apiService}luong/TaiDuLieuTinhLuongBoSungNLD`,
        layDuLieuDieuChinhLuongBoSungNguoiLD: `${apiService}luong/TaiDuLieuDieuChinhLuongBoSungNLD`,
        layDsLuongBoSung: `${apiService}luong/LayDanhSachLuongBoSung`,
        layDanhSachNhanVienMucLuongBHXHTrongThang: `${apiService}luong/LayDanhSachNhanVienMucLuongBHXHTrongThang`,

        layDsLuongBoSungNQL: `${apiService}luong/LayDsLuongBoSungNQL`,
        luuLuongBoSungNQL: `${apiService}luong/LuuLuongBoSungNQL`,
        layLuongBoSungNQL: `${apiService}luong/LayLuongBoSungNQL`,
        tinhLuongBoSungNQL: `${apiService}luong/tinhLuongBoSungNQL`,
        xoaLuongBoSungNQL: `${apiService}luong/xoaLuongBoSungNQL`,
        xoaLuongQuyetToanNLD: `${apiService}luong/xoaLuongQuyetToanNLD`,
        trinhLuongBoSungNQL: `${apiService}luong/trinhLuongBoSungNQL`,
        duyetLuongBoSungNQL: `${apiService}luong/duyetLuongBoSungNQL`,
        trinhLuongQuyetToanNLD: `${apiService}luong/trinhLuongQuyetToanNLD`,
        duyetLuongQuyetToanNLD: `${apiService}luong/duyetLuongQuyetToanNLD`,

        layChiTietLuongBoSung: `${apiService}luong/LayChiTietLuongQuyetToan`,
        luuDieuChinhLuongBoSungNLD: `${apiService}luong/LuuLuongBoSungDieuChinhNguoiLaoDong`,
        taiDuLieuTinhLuongBoSungNLDTheoNam: `${apiService}luong/TaiDuLieuTinhLuongBoSungNLDTheoNam`,
        layDsPhuCapTGV: `${apiService}PhuCapToGiupViec/LayDsPhuCapToGiupViec`,
        layDsPhuCapTGVTheoNam: `${apiService}PhuCapToGiupViec/LayDsPhuCapToGiupViecTheoNam`,
        tinhPhuCapTGV: `${apiService}PhuCapToGiupViec/TinhPhuCapToGiupViec`,
        luuPhuCapTGV: `${apiService}PhuCapToGiupViec/LuuPhuCapToGiupViec`,
        layChiTietPhuCapTGV: `${apiService}PhuCapToGiupViec/LayChiTietPhuCapToGiupViec`,
        trinhLuongPhuCapToGiaoViec: `${apiService}PhuCapToGiupViec/TrinhLuongPhuCapToGiupViec`,
        xoaLuongPhuCapToGiaoViec: `${apiService}PhuCapToGiupViec/XoaLuongPhuCapToGiupViec`,
        duyetLuongPhuCapToGiaoViec: `${apiService}PhuCapToGiupViec/DuyetLuongPhuCapToGiupViec`,
        xacNhanLuongPhuCapToGiaoViec: `${apiService}PhuCapToGiupViec/XacNhanLuongPhuCapToGiupViec`,
        xuatExcelPhuCapToGiupViec: `${apiService}PhuCapToGiupViec/XuatExcelPhuCapToGiupViec`,

        layDsOptionCauHinhThanhPhan: `${apiService}Luong/LayDsOptionLuongThanhPhan`,
        luuChiTietLuongThanhPhan: `${apiService}Luong/LuuChiTietLuongThang`,

        luuKhenThuongUngHo: `${apiService}Luong/LuuKhenThuongUngHo`,
        xoaLuongKhenThuongUngHo: `${apiService}Luong/XoaLuongKhenThuongUngHo`,
        luuPhatSinhTinhThue: `${apiService}Luong/LuuPhatSinhTinhThue`,
        xoaPhatSinhTinhThue: `${apiService}Luong/XoaPhatSinhTinhThue`,
        layMauFileLuongPhatSinh: `${apiService}Luong/LayMauLuongPhatSinh`,
        importFileLPS: `${apiService}Luong/ImportFileLuongPhatSinh`,
        importFileCongDoanPhi: `${apiService}Luong/ImportFileCongDoanPhi`,
        xuatExcelLuongPhatSinh: `${apiService}Luong/XuatDuLieuLuongPhatSinh`,
        importFilePhatSinhTinhThue: `${apiService}Luong/ImportFilePhatSinhTinhThue`,
        xuatExcelPhatSinhTinhThue: `${apiService}Luong/XuatDuLieuPhatSinhTinhThue`,

        layDsLuongCoBan: `${apiService}Luong/LayDsLuongCoBan`,
        khoiTaoLuongCoBan: `${apiService}Luong/KhoiTaoLuongCoBan`,
        layDsKhenThuongUngHoTheoNam: `${apiService}Luong/LayDsLuongKhenThuongUngHoTheoNam`,
        layDsPhatSinhTinhThueTheoNam: `${apiService}Luong/LayDsPhatSinhTinhThueTheoNam`,
        layDsLuongCoBanTamUngTheoNam: `${apiService}Luong/LayDsLuongCoBanTamUngTheoNam`,
        layThongTinLuongCoBan: `${apiService}Luong/LayThongTinLuongCoBan`,
        taiLuongCoBan: `${apiService}Luong/TaiLuongCoBan`,
        layChiTietLuongCoBan: `${apiService}Luong/LayChiTietLuongCoBan`,
        luuLuongCoBan: `${apiService}Luong/LuuLuongCoBan`,
        duyetLuongCoBan: `${apiService}Luong/DuyetLuongCoBan`,
        capNhatDuLieuThamChieuLuongCoBan: `${apiService}Luong/CapNhatDuLieuThamChieuLuongCoBan`,
        luuDieuChinhChiTietLuong: `${apiService}Luong/LuuDieuChinhChiTietLuong`,
        xuatExcelLuongCoBan: `${apiService}Luong/XuatExcelLuongCoBan`,
        importFileLuongCoBan: `${apiService}Luong/ImportFileLuongCoBan`,
        // Lương Phụ Cấp
        timKiemDsBangLuongPhuCap: `${apiService}Luong/TimKiemDsBangLuongPhuCap`,
        layDsBangLuongPhuCapTamUngTheoNam: `${apiService}Luong/LayDsBangLuongPhuCapTamUngTheoNam`,
        layDsBangLuongPhuCapTheoNam: `${apiService}Luong/LayDsBangLuongPhuCapTheoNam`,
        khoiTaoBangLuongPhuCap: `${apiService}Luong/KhoiTaoBangLuongPhuCap`,
        layThongTinBangLuongPhuCap: `${apiService}Luong/LayThongTinBangLuongPhuCap`,
        taiDuLieuLuongPhuCap: `${apiService}Luong/TaiDuLieuLuongPhuCap`,
        chiTietLuongPhuCap: `${apiService}Luong/ChiTietLuongPhuCap`,
        luuLuongPhuCap: `${apiService}Luong/LuuLuongPhuCap`,
        duyetLuongPhuCap: `${apiService}Luong/DuyetLuongPhuCap`,
        luuDieuChinhChiTietLuongPhuCap: `${apiService}Luong/LuuDieuChinhChiTietLuongPhuCap`,
        xuatExcelLuongPhuCap: `${apiService}Luong/XuatExcelLuongPhuCap`,
        importFileLuongPhuCap: `${apiService}Luong/ImportFileLuongPhuCap`,
        // - Lương hoàn thành nhiệm vụ - //
        timKiemDsLuongHoanThanhNhiemVu: `${apiService}Luong/TimKiemDsLuongHoanThanhNhiemVu`,
        layDsLuongHoanThanhNhiemVuTheoNam: `${apiService}Luong/LayDsLuongHoanThanhNhiemVuTheoNam`,
        khoiTaoLuongHoanThanhNhiemVu: `${apiService}Luong/KhoiTaoLuongHoanThanhNhiemVu`,
        layThongTinLuongHoanThanhNhiemVu: `${apiService}Luong/LayThongTinLuongHoanThanhNhiemVu`,
        taiDuLieuLuongHoanThanhNhiemVu: `${apiService}Luong/TaiDuLieuLuongHoanThanhNhiemVu`,
        chiTietLuongHoanThanhNhiemVu: `${apiService}Luong/ChiTietLuongHoanThanhNhiemVu`,
        luuLuongHoanThanhNhiemVu: `${apiService}Luong/LuuLuongHoanThanhNhiemVu`,
        duyetLuongHoanThanhNhiemVu: `${apiService}Luong/DuyetLuongHoanThanhNhiemVu`,
        luuDieuChinhChiTietLuongHoanThanhNhiemVu: `${apiService}Luong/LuuDieuChinhChiTietLuongHoanThanhNhiemVu`,
        capNhatQuyLuongHoanThanhNhiemVu: `${apiService}Luong/CapNhatQuyLuongHoanThanhNhiemVu`,
        capNhatThangLayDuLieuHoanThanhNhiemVu: `${apiService}Luong/CapNhatThangLayDuLieuHoanThanhNhiemVu`,
        xuatExcelLuongHoanThanhNhiemVu: `${apiService}Luong/XuatExcelLuongHoanThanhNhiemVu`,
        // - Lương bổ sung trưởng BKS - //
        timKiemDsLuongBoSungTruongBKS: `${apiService}Luong/TimKiemDsLuongBoSungTruongBKS`,
        layDsLuongBoSungTruongBKSTheoNam: `${apiService}Luong/LayDsLuongBoSungTruongBKSTheoNam`,
        layDsLuongCoBanChoLuongBSTBKS: `${apiService}Luong/LayDsLuongCoBanChoLuongBSTBKS`,
        khoiTaoLuongBoSungTruongBKS: `${apiService}Luong/KhoiTaoLuongBoSungTruongBKS`,
        layThongTinLuongBoSungTruongBKS: `${apiService}Luong/LayThongTinLuongBoSungTruongBKS`,
        taiDuLieuLuongBoSungTruongBKS: `${apiService}Luong/TaiDuLieuLuongBoSungTruongBKS`,
        chiTietLuongBoSungTruongBKS: `${apiService}Luong/ChiTietLuongBoSungTruongBKS`,
        luuLuongBoSungTruongBKS: `${apiService}Luong/LuuLuongBoSungTruongBKS`,
        duyetLuongBoSungTruongBKS: `${apiService}Luong/DuyetLuongBoSungTruongBKS`,
        luuDieuChinhChiTietLuongBoSungTruongBKS: `${apiService}Luong/LuuDieuChinhChiTietLuongBoSungTruongBKS`,
        capNhatQuyLuongBoSungTruongBKS: `${apiService}Luong/CapNhatQuyLuongBoSungTruongBKS`,
        xuatExcelLuongBoSungTruongBKS: `${apiService}Luong/XuatExcelLuongBoSungTruongBKS`,
        // - Lương thêm giờ - //
        timKiemDsLuongThemGio: `${apiService}Luong/TimKiemDsLuongThemGio`,
        layDsLuongThemGioTheoNam: `${apiService}Luong/LayDsLuongThemGioTheoNam`,
        khoiTaoLuongThemGio: `${apiService}Luong/KhoiTaoLuongThemGio`,
        layThongTinLuongThemGio: `${apiService}Luong/LayThongTinLuongThemGio`,
        taiDuLieuLuongThemGio: `${apiService}Luong/TaiDuLieuLuongThemGio`,
        chiTietLuongThemGio: `${apiService}Luong/ChiTietLuongThemGio`,
        luuLuongThemGio: `${apiService}Luong/LuuLuongThemGio`,
        duyetLuongThemGio: `${apiService}Luong/DuyetLuongThemGio`,
        luuDieuChinhChiTietLuongThemGio: `${apiService}Luong/LuuDieuChinhChiTietLuongThemGio`,
        capNhatQuyLuongThemGio: `${apiService}Luong/CapNhatQuyLuongThemGio`,
        xuatExcelLuongThemGio: `${apiService}Luong/XuatExcelLuongThemGio`,
        // - Lương tháng - //
        layDsLuongThang_V2: `${apiService}Luong/LayDsLuong`,
        khoiTaoLuongThang_V2: `${apiService}Luong/KhoiTaoLuong`,
        layThongTinLuongThang_V2: `${apiService}Luong/LayThongTinLuong`,
        taiLuongThang_V2: `${apiService}Luong/TaiLuong`,
        layChiTietLuongThang_V2: `${apiService}Luong/LayChiTietLuong`,
        luuLuongThang_V2: `${apiService}Luong/LuuLuong`,
        duyetLuongThang_V2: `${apiService}Luong/DuyetLuong`,
        xacNhanTruocThueLuongThang_V2: `${apiService}Luong/XacNhanTruocThue`,
        xacNhanThucNhanLuongThang_V2: `${apiService}Luong/XacNhanThucNhan`,
        capNhatDuLieuThamChieuLuongThang_V2: `${apiService}Luong/CapNhatDuLieuThamChieuLuong`,
        xuatExcelLuongThang_V2: `${apiService}Luong/XuatExcelLuongThang`,
        // - Lương tháng - Để làm options //
        layDsLuongCoBanTheoNam: `${apiService}Luong/LayDsLuongCoBanTheoNam`,
        layThuNhapLuongThangCaNhan: `${apiService}Luong/LayThuNhapLuongThangCaNhan`,
        xoaBangLuong: `${apiService}Luong/XoaBangLuong`,
        xoaBangLuongCoBan: `${apiService}Luong/XoaBangLuongCoBan`,
        xoaBangLuongPhuCap: `${apiService}Luong/XoaBangLuongPhuCap`,
        xoaBangLuongThemGio: `${apiService}Luong/XoaBangLuongThemGio`,
        xoaBangLuongHoanThanhNhiemVu: `${apiService}Luong/XoaBangLuongHoanThanhNhiemVu`,
        xoaBangLuongBoSungTruongBKS: `${apiService}Luong/XoaBangLuongBoSungTruongBKS`,
    },
    danhMuc: {
        ChucVu: `${apiService}danhmuc/LayDanhMucChucVu`,
        ChucVuResponse: `${apiService}danhmuc/LayDanhMucChucVuResponse`,
        luuChucVu: `${apiService}danhmuc/LuuChucVu`,
        xoaChucVu: `${apiService}danhmuc/XoaChucVu`,
        NhomNhanSu: `${apiService}danhmuc/LayTatCaDSNhomNhanSu`,
        luuNhomNhanSu: `${apiService}danhmuc/LuuNhomNhanSu`,
        xoaNhomNhanSu: `${apiService}danhmuc/XoaNhomNhanSu`,
        ChucDanhChuyenMon: `${apiService}danhmuc/LayTatCaDSChucDanhChuyenMon`,
        luuChucDanhChuyenMon: `${apiService}danhmuc/LuuChucDanhChuyenMon`,
        xoaChucDanhChuyenMon: `${apiService}danhmuc/XoaChucDanhChuyenMon`,
        TrinhDoLLCT: `${apiService}danhmuc/LayTatCaDSTrinhDoLLCT`,
        BacLuong: `${apiService}danhmuc/LayTatCaDSBacLuong`,
        luuBacLuong: `${apiService}danhmuc/LuuBacLuong`,
        xoaBacLuong: `${apiService}danhmuc/XoaBacLuong`,
        LoaiNghiPhep: `${apiService}danhmuc/LayTatCaDSLoaiNghiPhep`,
        DanToc: `${apiService}danhmuc/LayTatCaDSDanToc`,
        QuocTich: `${apiService}danhmuc/LayTatCaDSQuocTich`,
        TonGiao: `${apiService}danhmuc/LayTatCaDSTonGiao`,
        TrinhDoVanHoa: `${apiService}danhmuc/LayTatCaDSTrinhDoVanHoa`,
        ChucVuDang: `${apiService}danhmuc/LayTatCaDSChucVuDang`,
        chucVuDang: `${apiService}danhmuc/LayDanhMucChucVuDang`,
        luuChucVuDang: `${apiService}danhmuc/LuuChucVuDang`,
        xoaChucVuDang: `${apiService}danhmuc/XoaChucVuDang`,
        ChucVuDoan: `${apiService}danhmuc/LayTatCaDSChucVuDoan`,
        chucVuDoan: `${apiService}danhmuc/LayDanhMucChucVuDoan`,
        luuChucVuDoan: `${apiService}danhmuc/LuuChucVuDoan`,
        xoaChucVuDoan: `${apiService}danhmuc/XoaChucVuDoan`,
        ketQuaDanhGia: `${apiService}danhmuc/LayDanhMucKetQuaDanhGia`,
        heSoLuong: `${apiService}danhmuc/LayDanhMucHeSoLuongTheoBacLuong`,
        HeSoLuong: `${apiService}danhmuc/LayDanhMucHeSoLuong`,
        HeSoLuongResponse: `${apiService}danhmuc/LayDanhMucHeSoLuongResponse`,
        luuHeSoLuong: `${apiService}danhmuc/LuuHeSoLuong`,
        xoaHeSoLuong: `${apiService}danhmuc/XoaHeSoLuong`,
        phuCap: `${apiService}danhmuc/LayDanhMucPhuCap`,
        loaiHopDong: `${apiService}danhmuc/LayDanhMucLoaiHopDong`,
        luuLoaiHopDong: `${apiService}danhmuc/LuuLoaiHopDong`,
        xoaLoaiHopDong: `${apiService}danhmuc/XoaLoaiHopDong`,
        nhanVien: `${apiService}danhmuc/LayDuLieuSelectBoxNhanVien`,
        HocHam: `${apiService}danhmuc/LayTatCaDSHocHam`,
        ChuyenNganhDaoTao: `${apiService}danhmuc/LayTatCaDSChuyenNganhDaoTao`,
        luuChuyenNganhDaoTao: `${apiService}danhmuc/LuuChuyenNganhDaoTao`,
        xoaChuyenNganhDaoTao: `${apiService}danhmuc/XoaChuyenNganhDaoTao`,
        HinhThucDaoTao: `${apiService}danhmuc/LayTatCaDSHinhThucDaoTao`,
        XepLoaiTotNghiep: `${apiService}danhmuc/LayTatCaDSXepLoaiTotNghiep`,
        thongKeTrangChu: `${apiService}danhmuc/ThongKeTrangChu`,
        duLieuThuNhapCaNhan: `${apiService}danhmuc/LayDuLieuThuNhapCaNhan`,
        chiTietThuNhapCaNhan: `${apiService}danhmuc/ChiTietThuNhapCaNhanTheoThangNam`,
        loaiNgayNghi: `${apiService}danhmuc/LayDanhMucLoaiNgayNghi`,
        quanHePhuThuoc: `${apiService}danhmuc/LayDsDMQuanHePhuThuoc`, 
        layCauHinhPhuCap: `${apiService}danhmuc/LayCauHinhPhuCap`,
        xoaCauHinhPhuCap: `${apiService}danhmuc/XoaCauHinhPhuCap`,
        luuCauHinhPhuCap: `${apiService}danhmuc/LuuCauHinhPhuCap`,
        layDanhSachThongBaoLogin: `${apiService}danhmuc/LayDanhSachThongBaoLogin`,
        luuThongBaoLogin: `${apiService}danhmuc/LuuThongBaoLogin`,
        xoaThongBaoLogin: `${apiService}danhmuc/XoaThongBaoLogin`,
        QuyetDinh: `${apiService}danhmuc/LayDanhMucQuyetDinh`,
        luuDmQuyetDinh: `${apiService}danhmuc/LuuDanhMucQuyetDinh`,
        xoaDmQuyetDinh: `${apiService}danhmuc/XoaDanhMucQuyetDinh`,
        nhomLyDoNghiViec: `${apiService}danhmuc/LayDanhMucNhomLyDoNghiViec`,
        luuNhomLyDoNghiViec: `${apiService}danhmuc/LuuNhomLyDoNghiViec`,
        xoaNhomLyDoNghiViec: `${apiService}danhmuc/XoaNhomLyDoNghiViec`,
        layDSHocHam: `${apiService}danhmuc/LayDSHocHam`,
        luuHocHam: `${apiService}danhmuc/LuuHocHam`,
        xoaHocHam: `${apiService}danhmuc/XoaHocHam`,
        loaiTaiSan: `${apiService}danhmuc/LayDanhMucLoaiTaiSan`,
    },
    chamCong: {
        luuTaiLieuChamCong: `${apiService}chamCong/LuuTaiLieuChamCong`,
        layDanhSachChamCong: `${apiService}chamCong/layDanhSachChamCong`,
        layDanhSachChoDuyet: `${apiService}chamCong/layDanhSachChamCongChoDuyet`,
        luuChamCong: `${apiService}chamCong/LuuChamCong`,
        layMauChamCong: `${apiService}chamCong/LayMauChamCong`,
        taiDuLieuChamCongThang: `${apiService}chamCong/TaiDuLieuChamCongThang`,
        layChamCongThang: `${apiService}chamCong/LayChamCongThang`,
        thuHoiChamCong: `${apiService}chamCong/ThuHoiChamCong`,
        trinhLDPhongChamCong: `${apiService}chamCong/TrinhLDPhongChamCong`,
        lDPhongDuyetChamCong: `${apiService}chamCong/LDPhongDuyetChamCong`,
        lDPhuTrachDuyetChamCong: `${apiService}chamCong/LDPhuTrachDuyetChamCong`,
        importFileChamCong: `${apiService}chamCong/ImportFileChamCong`,
        xoaChamCong: `${apiService}chamCong/XoaChamCong`,
        getChamCongNhat: `${apiService}chamCong/GetChamCongNhat`,
        getLoaiCong: `${apiService}chamCong/GetLoaiCong`,
        chamCongNhat: `${apiService}chamCong/ChamCongNhat`,
        getDayInMonth: `${apiService}chamCong/GetDayInMonth`,
        layTaiLieuChamCong: `${apiService}chamCong/LayTaiLieuChamCong`,
        layThongKe: `${apiService}chamCong/LayThongKe`,
        xuatBaoCao: `${apiService}chamCong/XuatThongKe`,
        xuatBaoCaoTongHop: `${apiService}chamCong/XuatThongKeTongHop`,
        layNgayCongNhanVien: `${apiService}chamCong/LayNgayCongNhanVien`,
        trinhTongHopChamCongThang:`${apiService}chamCong/TrinhTongHopChamCongThang`,
        pheDuyetTongHopChamCongThang:`${apiService}chamCong/PheDuyetTongHopChamCongThang`,
        layTongHopChamCongThang: `${apiService}chamCong/LayTongHopChamCongThang`,
        thuHoiTongHopChamCong: `${apiService}chamCong/ThuHoiTongHopChamCong`,
        thongKeBangChamCongTheoDonVi: `${apiService}chamCong/ThongKeBangChamCongTheoDonVi`,
        vanPhongTraLaiChamCongTongHop: `${apiService}chamCong/vanPhongTraLaiChamCongTongHop`,
    },
    chamCongNgoaiGio: {
        layDanhSachChamNgoaiGio: `${apiService}chamCongngoaigio/layDanhSachChamNgoaiGio`,
        layDanhSachChamNgoaiGioChoDuyet: `${apiService}chamCongngoaigio/layDanhSachChamNgoaiGioChoDuyet`,
        layMauNgoaiGio: `${apiService}chamCongngoaigio/LayMauChamNgoaiGio`,
        importFileNgoaiGio: `${apiService}chamCongngoaigio/ImportFileChamNgoaiGio`,
        luuChamNgoaiGio: `${apiService}chamCongngoaigio/LuuChamNgoaiGio`,
        layChamNgoaiGio: `${apiService}chamCongngoaigio/LayChamNgoaiGio`,
        thuHoiNgoaiGio: `${apiService}chamCongngoaigio/ThuHoiNgoaiGio`,
        trinhLDPhongNgoaiGio: `${apiService}chamCongngoaigio/TrinhLDPhongNgoaiGio`,
        lDPhongDuyetNgoaiGio: `${apiService}chamCongngoaigio/LDPhongDuyetNgoaiGio`,
        trinhLDPhuTrachNgoaiGio: `${apiService}chamCongngoaigio/TrinhLDPhuTrachNgoaiGio`,
        lDPhuTrachDuyetNgoaiGio: `${apiService}chamCongngoaigio/LDPhuTrachDuyetNgoaiGio`,
        xoaNgoaiGio: `${apiService}chamCongngoaigio/XoaNgoaiGio`,
        taiDuLieuChamNgoaiGio: `${apiService}chamCongngoaigio/TaiDuLieu`,
    },
    kpi: {
        layDsKPICaNhan: `${apiService}kpi/layDsKPICaNhan`,
        luuKPICaNhan: `${apiService}kpi/luuKPI`, 
        luuTaiLieuKPI: `${apiService}kpi/LuuTaiLieuKPI`,
        luuChiTietKPICaNhan: `${apiService}kpi/luuChiTietKPITrangChu`,
        luuGiaoViecKPI: `${apiService}kpi/LuuGiaoViecKPI`,
        lienKetKPIDenNhanVienKhac: `${apiService}kpi/LienKetKPIDenNhanVienKhac`,
        SaoChepChiTietKPI: `${apiService}kpi/SaoChepChiTietKPI`,
        SaoChepChiTietKPILoi: `${apiService}kpi/SaoChepChiTietKPILoi`,
        luuLoiViPhamKPI: `${apiService}kpi/LuuLoiViPhamKPI`,
        xoaLoiViPhamKPI: `${apiService}kpi/XoaLoiViPhamKPI`,
        layNhomKPICaNhan: `${apiService}kpi/layNhomKPI`,
        layDSChiTietKPIChuaHoanThanh: `${apiService}kpi/LayDSChiTietKPIChuaHoanThanh`, 
        layDSTieuDeKPITheoNhanVien: `${apiService}kpi/LayDSTieuDeKPITheoNhanVien`, 
        layKPICaNhan: `${apiService}kpi/layKPICaNhan`,
        layThongTinNhanVien: `${apiService}kpi/LayThongTinNhanVienKPI`,
        xoaKPICaNhan: `${apiService}kpi/xoaKPICaNhan`,
        trinhLanhDaoPhong: `${apiService}kpi/trinhLanhDaoPhong`,
        trinhLanhDaoPhuTrach: `${apiService}kpi/trinhLanhDaoPhuTrach`,
        trinhLanhDaoDonVi: `${apiService}kpi/trinhLanhDaoDonVi`,
        pheDuyetKPICaNhan: `${apiService}kpi/pheDuyetKPICaNhan`,
        duaYKienKPICaNhan: `${apiService}kpi/duaYKienKPICaNhan`,
        LDPTPheDuyetKPICaNhan: `${apiService}kpi/LDPTPheDuyetKPICaNhan`,
        thuHoiKPICaNhan: `${apiService}kpi/thuHoiKPICaNhan`,
        importFileKPI: `${apiService}kpi/importFileKPI`,
        downloadFileTemplateKPI: `${apiService}kpi/downloadFileTemplateKPI`,
        layDsKPIPhongBan: `${apiService}kpi/layDsKPIPhongBan`,
        layDsKPIDuyet: `${apiService}kpi/layDsKPIDuyet`,
        layDsKPIYKien: `${apiService}kpi/layDsKPIYKien`,
        themTongHopKPIThang: `${apiService}kpi/themTongHopKPIThang`,
        layTongHopKPIThang: `${apiService}kpi/layTongHopKPIThang`,
        lanhDaoPhongPheDuyet: `${apiService}kpi/lanhDaoPhongPheDuyetKPI`,
        lanhDaoPhongTrinh: `${apiService}kpi/lanhDaoPhongTrinhKPI`,
        layDSLoiViPhamKPICaNhan: `${apiService}kpi/LayDSLoiViPhamKPICaNhan`, 
        thongKeKPICaNhan: `${apiService}kpi/ThongKeKPICaNhan`,
        thongKeKPIPhongBan: `${apiService}kpi/ThongKeKPIPhongBan`,
        timKiemGiaoViecKPI: `${apiService}kpi/TimKiemGiaoViecKPI`,
        anGiaoViecKPI: `${apiService}kpi/AnGiaoViecKPI`,
        suaGiaoViecKPI: `${apiService}kpi/SuaGiaoViecKPI`,
        xoaGiaoViecKPI: `${apiService}kpi/XoaGiaoViecKPI`,
        layDSLoiViPhamKPI: `${apiService}kpi/LayDSLoiViPhamKPI`, 
        thuHoiTongHopKPI: `${apiService}kpi/ThuHoiTongHopKPI`,
        pheDuyetTongHopKPI: `${apiService}kpi/PheDuyetTongHopKPI`,
        vanPhongTraLaiKPICaNhan: `${apiService}kpi/vanPhongTraLaiKPICaNhan`,
        layMauImportKPI: `${apiService}kpi/LayMauImportKPI`,
        layHanChotTrinhKPI: `${apiService}kpi/LayHanChotTrinhKPI`,
        layDSTieuDeKPI: `${apiService}kpi/LayDSTieuDeKPI`,
        luuDSTieuDeKPI: `${apiService}kpi/LuuDSTieuDeKPI`,
    },
    daoTao: {
        timKiemDSLopDaoTao: `${apiService}daotao/TimKiemDSLopDaoTao`,
        timKiemDSLopDaoTaoTheoKH: `${apiService}daotao/TimKiemDSLopDaoTaoTheoKH`,
        luu: `${apiService}daotao/LuuLopDaoTao`,
        xoa: `${apiService}daotao/XoaLopDaoTao`,
        chitiet: `${apiService}daotao/LayCT`,
        layDsNhanVien: `${apiService}daotao/LayDsNhanVienTheoLopDaoTao`,
        luuDsNhanVien: `${apiService}daotao/LuuDsNhanVien`,
        luuDangKyDaoTaoBoSung: `${apiService}daotao/LuuDangKyDaoTaoBoSung`,
        xoaDangKyDaoTaoBoSung: `${apiService}daotao/XoaDangKyDaoTaoBoSung`,
        khoiTaoLopDaoTaoKeHoach: `${apiService}daotao/KhoiTaoLopDaoTaoKeHoach`,
        capNhatKetQuaDaoTao: `${apiService}daotao/CapNhatKetQuaDaoTao`,
        hoanThanhLopDaoTao: `${apiService}daotao/HoanThanhLopDaoTao`,
        layTongHopDaoTao: `${apiService}daotao/LayTongHopDaoTao`,
        layThongKeDaoTaoTheoDonVi: `${apiService}daotao/LayThongKeDaoTaoTheoDonVi`,
        layDSNhanVienChuaHoanThanhDaoTao: `${apiService}daotao/LayDSNhanVienChuaHoanThanhDaoTao`,
        layDSChungChiSapHetHan: `${apiService}daotao/LayDSChungChiSapHetHan`,
        layLichSuDaoTaoTheoNhanVien: `${apiService}daotao/LayLichSuDaoTaoTheoNhanVien`,
    },
    dangKyDaoTao: {
        layDSTongHopDangKyDaoTao: `${apiService}daotao/LayDSTongHopDangKyDaoTao`,
        layPhoGiamDocDuyet: `${apiService}daotao/LayPhoGiamDocDuyet`,
        layPhoCVPDuyet: `${apiService}daotao/LayPhoCVPDuyet`,
        layChanhVPDuyet: `${apiService}daotao/LayChanhVPDuyet`,
        layGiamDocDuyet: `${apiService}daotao/LayGiamDocDuyet`,
        luuDangKyDaoTaoNam: `${apiService}daotao/LuuDangKyDaoTaoNam`,
        luuNoiDungDangKyDaoTaoNam: `${apiService}daotao/LuuNoiDungDangKyDaoTaoNam`,
        pheDuyetTongHopDKDT: `${apiService}daotao/PheDuyetTongHopDKDT`,
        duyetChiTietTongHopDKDT: `${apiService}daotao/DuyetChiTietTongHopDKDT`,
        pheDuyetLopDaoTao: `${apiService}daotao/pheDuyetLopDaoTao`,
        layCT: `${apiService}daotao/LayCTDangKyDaoTaoNam`,
        xoa: `${apiService}daotao/XoaDangKyDaoTaoNam`,
        layDSDangKyDaoTao: `${apiService}daotao/LayDSDangKyDaoTao`,
        layDSDuyetDangKyDaoTao: `${apiService}daotao/LayDSDuyetDangKyDaoTao`,
        layCTDangKyDaoTao: `${apiService}daotao/LayCTDangKyDaoTao`,
        layDSLopThamGia: `${apiService}daotao/LayDSLopThamGia`,
        luuDangKyDaoTao: `${apiService}daotao/LuuDangKyDaoTao`,
        xoaDangKyDaoTao: `${apiService}daotao/XoaDangKyDaoTao`,
        thuHoiDangKyDaoTao: `${apiService}daotao/ThuHoiDangKyDaoTao`,
        vanPhongTuChoi: `${apiService}daotao/VPTuChoiDangKyDaoTao`,
        lanhDaoPhongTrinhDangKyDaoTao: `${apiService}daotao/LanhDaoPhongTrinhDangKyDaoTao`,
        lanhDaoPhongDuyetCTDangKyDaoTao: `${apiService}daotao/LanhDaoPhongDuyetCTDangKyDaoTao`,
        gopLopDangKyDaoTao: `${apiService}daotao/GopLopDangKyDaoTao`,
        layTongHopDangKyDaoTaoNam: `${apiService}daotao/LayTongHopDangKyDaoTaoNam`,
        banHanhDangKyDaoTaoNam: `${apiService}daotao/BanHanhDangKyDaoTaoNam`,
        xuatKeHoachDaoTaoNam: `${apiService}Report/XuatKeHoachDaoTaoNam`,
        xuatPhieuTrinhDaoTaoNam: `${apiService}Report/XuatPhieuTrinhDaoTaoNam`,
    },
    toBan: {
        timKiemDSToBan: `${apiService}toBan/TimKiemDSToBan`,
        luu: `${apiService}toban/LuuToban`,
        xoa: `${apiService}toban/XoaToban`,
        chitiet: `${apiService}toban/LayCT`,
        luuDsNhanVien: `${apiService}toban/LuuDsNhanVien`
    },
    donNghiPhep: {
        LuuDonNghiPhep: `${apiService}donnghiphep/LuuDonNghiPhep`,
        LayThongTinNgayPhepTrongNam: `${apiService}donnghiphep/LayThongTinNgayPhepTrongNam`,
        LayNguoiDuyet_YKienPhepMacDinh:`${apiService}donnghiphep/LayNguoiDuyet_YKienPhepMacDinh`,
        LayCT: `${apiService}donnghiphep/LayCT`,
        Xoa: `${apiService}donnghiphep/Xoa`,
        DuyetDonNghiPhep: `${apiService}donnghiphep/DuyetDonNghiPhep`,
        HuyDonNghiPhep: `${apiService}donnghiphep/HuyDonNghiPhep`,
        DuaYKien: `${apiService}donnghiphep/DuaYKienDonNghiPhep`,
        ThuHoiNghiPhep: `${apiService}donnghiphep/ThuHoiNghiPhep`,
        YeuCauHuyNghiPhep: `${apiService}donnghiphep/YeuCauHuyNghiPhep`,
        LayDsDonNghiPhep: `${apiService}donnghiphep/LayDanhSachDonNghiPhep`,
        LayDsDonNghiPhepCaNhan: `${apiService}donnghiphep/LayDanhSachDonNghiPhepCaNhan`,
        LayDsNguoiDuyet: `${apiService}donnghiphep/LayDanhSachNguoiDuyet`,
        LayDSNvTheoNguoiDuyet: `${apiService}donnghiphep/LayDanhSachNhanVienTheoNguoiDuyet`,
        LuuNhanVienTheoNguoiDuyet: `${apiService}donnghiphep/LuuNhanVienTheoNguoiDuyet`,
        layDSDonNghiPhepChoPheDuyet: `${apiService}donnghiphep/LayDsDonNghiPhepChoPheDuyet`,
        LayDsNguoiYKien: `${apiService}donnghiphep/LayDanhSachNguoiYKien`,
        LayDSNvTheoNguoiYKien: `${apiService}donnghiphep/LayDanhSachNhanVienTheoNguoiYKien`,
        LuuNhanVienTheoNguoiYKien: `${apiService}donnghiphep/LuuNhanVienTheoNguoiYKien`,
        layDanhSachTongHopTheoThang: `${apiService}donnghiphep/LayDanhSachTongHopTheoThang`,
    },
    ngoaiGio: {
        luuDangKyNgoaiGio: `${apiService}ngoaiGio/LuuNgoaiGio`,
        trinhNgoaiGio: `${apiService}ngoaiGio/TrinhNgoaiGio`,
        LayCT: `${apiService}ngoaiGio/LayCT`,
        Xoa: `${apiService}ngoaiGio/Xoa`,
        layDangKyNgoaiGio: `${apiService}ngoaiGio/LayNgoaiGio`,
        layDanhSachDangKyNgoaiGio: `${apiService}ngoaiGio/LayDanhSachDangKy`,
        layDanhSachNguoiDuyet: `${apiService}ngoaiGio/LayDanhSachNguoiDuyet`,
        layDanhSachTongHopTheoThang: `${apiService}ngoaiGio/LayDanhSachTongHopTheoThang`,
        luuYkien: `${apiService}ngoaiGio/LuuYKien`,
        duyetDangKyNgoaiGio: `${apiService}ngoaiGio/DuyetDangKyNgoaiGio`,
        thuHoiNgoaiGio: `${apiService}ngoaiGio/ThuHoiNgoaiGio`,
        DuaYKien: `${apiService}ngoaiGio/DuaYKienDonNgoaiGio`,
        layDanhSachDonNgoaiGio: `${apiService}ngoaiGio/LayDanhSachDonNgoaiGio`,
        layDanhSachDonNgoaiGioCaNhan: `${apiService}ngoaiGio/LayDanhSachDonNgoaiGioCaNhan`,
        layDSDonNgoaiGioChoPheDuyet: `${apiService}ngoaiGio/LayDsDonNgoaiGioChoPheDuyet`
    },
    ngayPhepTrongNam:{
        layDanhSachNgayPhepTrongNam: `${apiService}ngaypheptrongnam/LayDanhSachNgayPhepTrongNam`,
        luuNgayPhepTrongNam: `${apiService}ngaypheptrongnam/LuuNgayPhepTrongNam`,
        khoiTaoPhepNam: `${apiService}ngaypheptrongnam/KhoiTaoPhepNam`,
        getListAnnualLeave: `${apiService}ngaypheptrongnam/GetListAnnualLeave`, 
    },
    baoHiem: {
        layDsBaoHiem : `${apiService}baohiem/LayDsBaoHiem`,
        layChiTietBaoHiem : `${apiService}baohiem/LayChiTietBaoHiem`,
        layThongTinBaoHiem: `${apiService}baohiem/LayThongTinBaoHiem`, 
        themBaoHiemThang: `${apiService}baohiem/ThemBaoHiemThang`,
        taiBaoHiemThang: `${apiService}baohiem/taiBaoHiemThang`,
        taiBaoHiemBoSungTheoListNhanVien: `${apiService}baohiem/taiBaoHiemBoSungTheoListNhanVien`,
        thongTinNhanSuTinhBaoHiem: `${apiService}baohiem/thongTinNhanSuTinhBaoHiem`,
        luuBaoHiemThang: `${apiService}baohiem/luuBaoHiemThang`,
        duyetBaoHiemThang: `${apiService}baohiem/duyetBaoHiemThang`,
        xuatBaoCao: `${apiService}baohiem/XuatBaoCao`,
        layDsBaoHiemTheoNam: `${apiService}baohiem/LayDsBaoHiemTheoNam`,
        xoaBaoHiemThang: `${apiService}baohiem/XoaBaoHiemThang`,
        importFileBaoHiem: `${apiService}baohiem/ImportFileBaoHiem`,
    },
    thuLaoNguoiDaiDien: {
        getList: `${apiService}thulaonguoidaidien/GetList`,
        getById: `${apiService}thulaonguoidaidien/GetById`,
        save: `${apiService}thulaonguoidaidien/Save`,
        trinh: `${apiService}thulaonguoidaidien/Trinh`,
        duyet: `${apiService}thulaonguoidaidien/Duyet`,
        xoa: `${apiService}thulaonguoidaidien/Xoa`,
        getDsNgDaiDien: `${apiService}thulaonguoidaidien/GetDsNguoiDaiDien`,
        xuatExcelThuLaoNguoiDaiDien: `${apiService}thulaonguoidaidien/XuatExcelThuLaoNguoiDaiDien`,
    },
    thuLaoKhongChuyenTrach: {
        layDs: `${apiService}thulaokhongchuyentrach/LayDsThuLaoKhongChuyenTrach`,
        layDsTheoNam: `${apiService}thulaokhongchuyentrach/LayDsThuLaoKhongChuyenTrachTheoNam`,
        tinhThuLao: `${apiService}thulaokhongchuyentrach/TinhThuLaoKhongChuyenTrach`,
        layChiTiet: `${apiService}thulaokhongchuyentrach/ThuLaoKhongChuyenTrachGetById`,
        luu: `${apiService}thulaokhongchuyentrach/LuuThuLaoKhongChuyenTrach`,
        trinhThuLaoKhongChuyenTrach: `${apiService}ThuLaoKhongChuyenTrach/TrinhThuLaoKhongChuyenTrach`,
        xoaThuLaoKhongChuyenTrach: `${apiService}ThuLaoKhongChuyenTrach/XoaThuLaoKhongChuyenTrach`,
        duyetThuLaoKhongChuyenTrach: `${apiService}ThuLaoKhongChuyenTrach/DuyetThuLaoKhongChuyenTrach`,
        xacNhanThuLaoKhongChuyenTrach: `${apiService}ThuLaoKhongChuyenTrach/XacNhanThuLaoKhongChuyenTrach`,
        xuatExcelThuLaoKhongChuyenTrach: `${apiService}ThuLaoKhongChuyenTrach/XuatExcelThuLaoKhongChuyenTrach`,
    },
    baoCao: {
        tongHopLuong: `${apiService}report/XuatBaoCaoLuong`,
        baoCaoNhanVien: `${apiService}report/XuatBaoCaoNhanVien`,
        baoCaoPhepNam: `${apiService}report/XuatBaoCaoNgayPhepTrongNam`,
        baoCaoDaoTao: `${apiService}report/XuatBaoCaoDaoTao`,
        donNghiPhep: `${apiService}report/XuatDonNghiPhep`,
        donNgoaiGio: `${apiService}report/XuatDonNgoaiGio`,
        baoCaoTongHopKPI: `${apiService}report/exportBaoCaoTongHopKPI`,
        danhGiaKetQuaKPI: `${apiService}report/exportDanhGiaKetQuaKPI`,
        xuatExcelNhanVienNghiViec: `${apiService}report/XuatExcelNhanVienNghiViec`,
        xuatExcelDieuDongLuanChuyen: `${apiService}report/XuatExcelDieuDongLuanChuyen`,
        xuatExcelNhanVienTheoThamNienCongTac: `${apiService}report/XuatExcelNhanVienTheoThamNienCongTac`,
        baoCaoCTNhanVienMoi: `${apiService}report/XuatBaoCaoChiTietNhanVienMoi`,
        xuatExcelLoiViPhamTrongNam: `${apiService}report/XuatExcelLoiViPhamTrongNam`,
        xuatExcelXepLoaiTrongNam: `${apiService}report/XuatExcelXepLoaiTrongNam`,
        xuatExcelGiaoViecKPI: `${apiService}report/ExportBaoCaoGiaoViecKPI`,
        xuatExcelThuNhapTrongNam: `${apiService}report/XuatExcelThuNhapTrongNam`,
        xuatExcelNguoiPhuThuocTrongNam: `${apiService}report/XuatExcelNguoiPhuThuocTrongNam`,
        xuatExcelNhanSuChuyenXepLuong: `${apiService}report/XuatExcelNhanSuChuyenXepLuong`,
    },
    ngayNghi: {
        timKiemDSNgayNghi: `${apiService}ngaynghi/TimKiemDSNgayNghi`,
        chiTiet: `${apiService}ngaynghi/LayCTNgayNghi`,
        luuNgayNghi: `${apiService}ngaynghi/LuuNgayNghi`,
        xoaNgayNghi: `${apiService}ngaynghi/XoaNgayNghi`,
    },
    congViec: {
        layDsCongViec: `${apiService}congViec/layDsCongViec`,
        luuCongViec: `${apiService}congViec/luuCongViec`,
        LayCT: `${apiService}congViec/LayCT`,
        layDsCongViecTheoNvKhoiTao: `${apiService}congViec/LayDSCongViecTheoNvKhoiTao`
    },
    thongBaoChung: {
        layDsThongBaoChungTrangChu: `${apiService}thongBaoChung/layDsThongBaoChungTrangChu`,
        CapNhatTrangThaiDoc: `${apiService}thongBaoChung/CapNhatTrangThaiDoc`,
    },
    home: {
        LayDSThongBaoTaiTrangLogin: `${apiService}home/LayDSThongBaoTaiTrangLogin`,
        LayCauHinhSinhNhatQuy: `${apiService}home/LayCauHinhSinhNhatQuy`
    },
    nhanSuKhac: {
        layDs: `${apiService}nhansukhac/LayTatCaDanhSachNhanSuKhac`,
        luuNhanSuKhac: `${apiService}nhansukhac/luuNhanSuKhac`,
        xoaNhanSuKhac: `${apiService}nhansukhac/xoaNhanSuKhac`,
        downloadFileMauLuongKhenThuongNSK: `${apiService}nhansukhac/loadFileMauLuongKhenThuong`,
        uploadFileMauLuongKhenThuongNSK: `${apiService}nhansukhac/ImportFileLuongKhenThuong`,
        luuKhenThuongNSK: `${apiService}nhansukhac/LuuKhenThuongNhanSuKhac`,
        layDSKhenThuongNSK: `${apiService}nhansukhac/LayDsKhenThuongNhanSuKhac`,
        layChiTietKhenThuongNSK: `${apiService}nhansukhac/LayChiTietKhenThuongNhanSuKhac`,
        xoaKhenThuongNSK: `${apiService}nhansukhac/XoaLuongKhenThuongNhanSuKhac`,
    },
    thue: {
        layDuLieuTinhThueKhongThuongXuyen: `${apiService}Thue/LayDuLieuTinhThueKhongThuongXuyen`,
        luuThueThangKhongThuongXuyen: `${apiService}Thue/LuuThueThangKhongThuongXuyen`,
        layDsKyThueKhongThuongXuyen: `${apiService}Thue/LayDanhSachKyThueKhongThuongXuyen`,
        layDuLieuThueThangKhongThuongXuyenTheoId: `${apiService}Thue/LayDuLieuThueThangKhongThuongXuyenTheoId`,
        layDSOptionCacKhoanTinhThueKhongThuongXuyen: `${apiService}Thue/LayDsOptionCacKhoanTinhThueKhongThuongXuyen`,
        luuQuyetToanThueTX: `${apiService}Thue/LuuQuyetToanThueThuongXuyen`,
        chiTietQuyetToanThueTX: `${apiService}Thue/GetChiTietQuyetToanThueThuongXuyen`,
        layDsQTThueThuongXuyen: `${apiService}Thue/LayDanhSachQuyetToanThueThuongXuyen`,
        xuatExcelThueTNCN: `${apiService}Thue/XuatExcelThueTNCN`,
        xuatExcelThueTNCN_KTX: `${apiService}Thue/XuatExcelThueTNCN_KTX`,
        layTongHopThueKTXTHeoNam: `${apiService}Thue/LayDuLieuTongHopThueKTXTheoNam`,

        luuDuLieuThuNhapTinhThue: `${apiService}thue/LuuDuLieuThuNhapTinhThue`,
        layDuLieuQuyetToanThue: `${apiService}thue/LayDuLieuQuyetToanThueThuongXuyen`,
        layDuLieuTinhThue: `${apiService}thue/LayDuLieuTinhThue`,
        luuThueThang: `${apiService}thue/LuuThueThang`,
        timKiemDsThueThang: `${apiService}Thue/TimKiemDsThueThang`,
        khoiTaoThueThang: `${apiService}thue/KhoiTaoThueThang`,
        xoaThueThang: `${apiService}Thue/XoaThueThang`,
        duyetThueThang: `${apiService}thue/DuyetThueThang`,
        layDanhSachKyThue: `${apiService}thue/LayDanhSachKyThue`,
        chiTietThueThang: `${apiService}thue/LayDuLieuThueThangTheoId`,

        // Nâng cấp:
        layDsThueThangTheoNam: `${apiService}Thue/LayDsThueThangTheoNam`,
        layThongTinThueThang: `${apiService}Thue/layThongTinThueThang`,
        layChiTietThueTNCNThang: `${apiService}Thue/ChiTietThueTNCNThang`,
        taiThueThang: `${apiService}Thue/TaiThueThang`,
        capNhat: `${apiService}Thue/TaiThueThang`,
        capNhatDuLieuThamChieuThueThang: `${apiService}Thue/CapNhatDuLieuThamChieuThueThang`,
        layDuLieuTongHopThue: `${apiService}Thue/LayDuLieuTongHopThue`,
        xuatExcelTongHopThue: `${apiService}Thue/XuatExcelTongHopThue`,

        // Mô-đun Tổng hợp thuế (Tháng/Quý/Năm):
        khoiTaoThueTongHop: `${apiService}Thue/KhoiTaoThueTongHop`,
        timKiemDsThueTongHop: `${apiService}Thue/TimKiemDsThueTongHop`,
        layThongTinThueTongHop: `${apiService}Thue/LayThongTinThueTongHop`,
        taiThueTongHop: `${apiService}Thue/TaiThueTongHop`,
        luuThueTongHop: `${apiService}Thue/LuuThueTongHop`,
        capNhatThamChieuThueTongHop: `${apiService}Thue/CapNhatThamChieuThueTongHop`,
        duyetThueTongHop: `${apiService}Thue/DuyetThueTongHop`,
        xoaThueTongHop: `${apiService}Thue/XoaThueTongHop`,
        xuatExcelThueTongHop: `${apiService}Thue/XuatExcelThueTongHop`
    },
    taiSan: {
        timKiemDSTaiSan: `${apiService}taisan/TimKiemDSTaiSan`,
        layChiTiet: `${apiService}taisan/LayChiTiet`,
        luuTaiSan: `${apiService}taisan/LuuTaiSan`,
        xoaTaiSan: `${apiService}taisan/XoaTaiSan`,
        thongKeTaiSan: `${apiService}taisan/ThongKeTaiSan`,
        layTaiSanTheoMaQR: `${apiService}taisan/LayTaiSanTheoMaQR`,
        sinhMaQR: `${apiService}taisan/SinhMaQR`,
        capNhatTrangThai: `${apiService}taisan/CapNhatTrangThai`,
        layDsTaiSanInQR: `${apiService}taisan/LayDsTaiSanInQR`,
        layDsTaiSanInQRToanBo: `${apiService}taisan/LayDsTaiSanInQRToanBo`,
        layDsTaiSanKiemKe: `${apiService}taisan/LayDsTaiSanKiemKe`,
        luuKetQuaKiemKe: `${apiService}taisan/LuuKetQuaKiemKe`,
        thongKeKiemKe: `${apiService}taisan/ThongKeKiemKe`,
        layBaoCaoKiemKe: `${apiService}taisan/LayBaoCaoKiemKe`,
        xuatBaoCaoKiemKe: `${apiService}taisan/XuatBaoCaoKiemKe`,
        themTaiSanPhu: `${apiService}taisan/ThemTaiSanPhu`,
        xoaTaiSanPhu: `${apiService}taisan/XoaTaiSanPhu`,
        layDsTaiSanPhu: `${apiService}taisan/LayDsTaiSanPhu`,
        layBangTongHopKiemKeBoPhan: `${apiService}taisan/LayBangTongHopKiemKeBoPhan`,
        xuatExcelBangTongHopKiemKeBoPhan: `${apiService}taisan/XuatExcelBangTongHopKiemKeBoPhan`,
        layBienBanTongHopKiemKe: `${apiService}taisan/LayBienBanTongHopKiemKe`,
        xuatExcelBienBanTongHopKiemKe: `${apiService}taisan/XuatExcelBienBanTongHopKiemKe`,
        layDsBoPhanKiemKe: `${apiService}taisan/LayDsBoPhanKiemKe`,
        luuDMBopPhanKiemKe: `${apiService}taisan/LuuDMBopPhanKiemKe`,
        xoaDMBopPhanKiemKe: `${apiService}taisan/XoaDMBopPhanKiemKe`,
        layDsCoSo: `${apiService}taisan/LayDsCoSo`,
        luuDMCoSo: `${apiService}taisan/LuuDMCoSo`,
        xoaDMCoSo: `${apiService}taisan/XoaDMCoSo`,
        layDsThanhVienKiemKe: `${apiService}taisan/LayDsThanhVienKiemKe`,
        luuDsThanhVienKiemKe: `${apiService}taisan/LuuDsThanhVienKiemKe`,
        xuatExcelDanhSachTaiSan: `${apiService}taisan/XuatExcelDanhSachTaiSan`,
    },
    dotKiemKeTaiSan: {
        timKiem: `${apiService}taisan/TimKiemDSDotKiemKe`,
        layChiTiet: `${apiService}taisan/LayChiTietDotKiemKe`,
        luu: `${apiService}taisan/LuuDotKiemKe`,
        xoa: `${apiService}taisan/XoaDotKiemKe`,
        capNhatTrangThai: `${apiService}taisan/CapNhatTrangThaiDotKiemKe`,
        trinhDuyet: `${apiService}taisan/TrinhDuyetDotKiemKe`,
        thuHoi: `${apiService}taisan/ThuHoiDotKiemKe`,
        pheDuyet: `${apiService}taisan/PheDuyetDotKiemKe`,
    },
    deXuatNhuCauTaiSan: {
        layDS: `${apiService}DeXuatNhuCauTaiSan/LayDSDexuatNhuCau`,
        layChiTiet: `${apiService}DeXuatNhuCauTaiSan/LayChiTietDeXuat`,
        luu: `${apiService}DeXuatNhuCauTaiSan/LuuDeXuat`,
        trinhDuyet: `${apiService}DeXuatNhuCauTaiSan/TrinhDuyetDeXuat`,
        thuHoi: `${apiService}DeXuatNhuCauTaiSan/ThuHoiDeXuat`,
        pheDuyet: `${apiService}DeXuatNhuCauTaiSan/PheDuyetDeXuat`,
        chuyenCVVP: `${apiService}DeXuatNhuCauTaiSan/ChuyenCVVPDeXuat`,
        tuChoi: `${apiService}DeXuatNhuCauTaiSan/TuChoiDeXuat`,
        trinhThamMuu: `${apiService}DeXuatNhuCauTaiSan/TrinhThamMuuDeXuat`,
        luuFileIn: `${apiService}DeXuatNhuCauTaiSan/LuuFileInDeXuat`,
    },
    bienBanKiemKe: {
        layDs: `${apiService}BienBanKiemKe/LayDsBienBanKiemKe`,
        layChiTiet: `${apiService}BienBanKiemKe/LayChiTietBienBanKiemKe`,
        layBangTongHop: `${apiService}BienBanKiemKe/LayBangTongHopKiemKe`,
        luu: `${apiService}BienBanKiemKe/LuuBienBanKiemKe`,
        xoa: `${apiService}BienBanKiemKe/XoaBienBanKiemKe`,
        xuatExcelPhongBan: `${apiService}BienBanKiemKe/XuatExcelBienBanKiemKePhongBan`,
    },
    bienBanBanGiao: {
        timKiem: `${apiService}BienBanBanGiao/TimKiemDSBienBanBanGiao`,
        layChiTiet: `${apiService}BienBanBanGiao/LayChiTiet`,
        luuBienBan: `${apiService}BienBanBanGiao/LuuBienBan`,
        guiYeuCau: `${apiService}BienBanBanGiao/GuiYeuCauBanGiao`,
        xacNhan: `${apiService}BienBanBanGiao/XacNhanBanGiao`,
        tuChoi: `${apiService}BienBanBanGiao/TuChoiBanGiao`,
        huyBienBan: `${apiService}BienBanBanGiao/HuyBienBan`,
        thuHoiBienBan: `${apiService}BienBanBanGiao/ThuHoiBienBan`,
        layDSTaiSan: `${apiService}BienBanBanGiao/LayDanhSachTaiSanCoTheBanGiao`,
        layTaiSanChinh: `${apiService}BienBanBanGiao/LayTaiSanChinh`,
        layDsTaiSanPhu: `${apiService}BienBanBanGiao/LayDsTaiSanPhu`,
    },
    thanhLyTaiSan: {
        timKiem: `${apiService}ThanhLyTaiSan/TimKiemDSPhieuThanhLy`,
        layChiTiet: `${apiService}ThanhLyTaiSan/LayChiTiet`,
        luuPhieu: `${apiService}ThanhLyTaiSan/LuuPhieu`,
        ghiGiam: `${apiService}ThanhLyTaiSan/GhiGiamTaiSan`,
        hoanThanh: `${apiService}ThanhLyTaiSan/HoanThanhThanhLy`,
        layDSTaiSan: `${apiService}ThanhLyTaiSan/LayDanhSachTaiSanCoTheThanhLy`,
    },
    quyLuong: {
        layDanhSach: `${apiService}QuyLuong/LayDanhSach`,
        layTheoNam: `${apiService}QuyLuong/LayTheoNam`,
        luu: `${apiService}QuyLuong/Luu`,
        xoa: `${apiService}QuyLuong/Xoa`,
    },
    keKhaiTaiSan: {
        timKiemCaNhan: `${apiService}KeKhaiTaiSan/TimKiemCaNhan`,
        timKiemToanDonVi: `${apiService}KeKhaiTaiSan/TimKiemToanDonVi`,
        layChiTiet: `${apiService}KeKhaiTaiSan/LayChiTiet`,
        luu: `${apiService}KeKhaiTaiSan/LuuKeKhai`,
        xoa: `${apiService}KeKhaiTaiSan/XoaKeKhai`,
        xuatBanKeKhai: `${apiService}KeKhaiTaiSan/XuatBanKeKhai`,
    }
};
